import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InventarioCapaService {

  constructor(private http: HttpClient) { }

  getAll(req: any): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(`Inventario?${req.inventarioStatusId ? `&inventarioStatusId=${req.inventarioStatusId}` : ''}
        ${req.dataInicial? `&dataInicial=${req.dataInicial}` : ''}
        ${req.inventarioId? `&inventarioId=${req.inventarioId}` : ''}
        ${req.dataFinal? `&dataFinal=${req.dataFinal}` : ''}
        ${req.paginaAtual ? `&paginaAtual=${(req.paginaAtual || 0) + 1}` : ''}
        ${req.itensPorPagina ? `&itensPorPagina=${req.itensPorPagina}` : ''}`,
        { observe: 'response' }
      );
  } 

  getInventarioContagemResumoQuantidadeStatus(req: any): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(`Inventario/Contagem/Resumo-Quantidade-Status?${req.inventarioId ? `inventarioId=${req.inventarioId}` : ''}
        ${req.inventarioContagemId? `&inventarioContagemId=${req.inventarioContagemId}` : ''}`,
        { observe: 'response' }
      );
  } 

  getInventarioContagemResumoQuantidadeStatusNaoConferidos(req: any): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(`Inventario/Contagem/Resumo-Quantidade-Status-Nao-Conferidos?${req.inventarioId ? `inventarioId=${req.inventarioId}` : ''}
        ${req.inventarioContagemId? `&inventarioContagemId=${req.inventarioContagemId}` : ''}
        ${req.paginaAtual ? `&paginaAtual=${(req.paginaAtual || 0) + 1}` : ''}
        ${req.itensPorPagina ? `&itensPorPagina=${req.itensPorPagina}` : ''}`,
        { observe: 'response' }
      );
  } 


  getAllInventarioContagens(req: any): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(`Inventario/contagens?${req.inventarioContagemId ? `&inventarioContagemId=${req.inventarioContagemId}` : ''}
      ${req.inventarioId? `&inventarioId=${req.inventarioId}` : ''}
      ${req.isMobile? `&isMobile=${req.isMobile}` : ''}`,
        { observe: 'response' }
      );
  } 

  
  getUltimaContagemInventario(req: any): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(`Inventario/Contagem/Ultima?${req.inventarioContagemId ? `&inventarioContagemId=${req.inventarioContagemId}` : ''}
      ${req.inventarioId? `&inventarioId=${req.inventarioId}` : ''}`,
        { observe: 'response' }
      );
  } 

  getUltimosItensContadosAsync(req: any): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(`Inventario/Contagens/recentes?${req.inventarioContagemId ? `&inventarioContagemId=${req.inventarioContagemId}` : ''}
        ${req.paginaAtual ? `&paginaAtual=${(req.paginaAtual || 0) + 1}` : ''}
        ${req.itensPorPagina ? `&itensPorPagina=${req.itensPorPagina}` : ''}`,
        { observe: 'response' }
      );
  } 

  exportarItensPrevistos(req: any): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(`Contagem/Itens-Previstos/Exportar?${req.inventarioContagemId ? `&inventarioContagemId=${req.inventarioContagemId}` : ''}`,
        { observe: 'response' }
      );
  } 

  exportarItensFaltantes(req: any): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(`Contagem/Itens-Faltantes/Exportar?${req.inventarioContagemId ? `&inventarioContagemId=${req.inventarioContagemId}` : ''}`,
        { observe: 'response' }
      );
  } 

  exportarItensContabilizados(req: any): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(`Contagem/Itens-Contabilizados/Exportar?${req.inventarioContagemId ? `&inventarioContagemId=${req.inventarioContagemId}` : ''}`,
        { observe: 'response' }
      );
  } 

  getAllStatus(): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(`Inventario/Status`,
        { observe: 'response' }
      );
  } 

  getInventarioContagemPedidosEncontrados(req: any): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(`Inventario/contagens/pedidos-encontrados?${req.pedidoDocumento? `&pedidoDocumento=${req.pedidoDocumento}` : ''}
        ${req.paginaAtual ? `&paginaAtual=${(req.paginaAtual || 0) + 1}` : ''}
        ${req.itensPorPagina ? `&itensPorPagina=${req.itensPorPagina}` : ''}`,
        { observe: 'response' }
      );
  } 

  createInventario(objectRequest: any): Observable<any> {
    return this.http.post(
        `Inventario`,
        objectRequest,
        { observe: 'response' }
      );
  }
  
  registrarInventarioContagemItem(objectRequest: any): Observable<any> {
    return this.http.post(
        `Inventario/contagens/itens`,
        objectRequest,
        { observe: 'response' }
      );
  }

  createInventarioContagem(objectRequest: any): Observable<any> {
    return this.http.post(
        `Inventario/${objectRequest.inventarioId}/contagem`,
        {},
        { observe: 'response' }
      );
  }

  cancelarInventarioContagem(objectRequest: any): Observable<any> {
    return this.http.put(
        `Inventario/${objectRequest.inventarioId}/contagem/${objectRequest.inventarioContagemId}/cancelar`,
        {},
        { observe: 'response' }
      );
  }

  encerrarInventarioContagem(objectRequest: any): Observable<any> {
    return this.http.put(
        `Inventario/${objectRequest.inventarioId}/contagem/${objectRequest.inventarioContagemId}/encerrar`,
        {},
        { observe: 'response' }
      );
  }

  updateInventarioStatus(objectRequest: any): Observable<any> {
    return this.http.put(
        `Inventario`,
        objectRequest,
        { observe: 'response' }
      );
  }
}
